export function LoopIcon() {
  return (
    <svg width="18" height="20" viewBox="0 0 18 20" aria-hidden="true" role="img" fill="#fff">
      <path d="M14 15H4v-3l-4 4 4 4v-3h12v-6h-2v4zM4 5h10v3l4-4-4-4v3H2v6h2V5z" />
    </svg>
  );
}
